import React from 'react'
import { Footer } from './Footer'
import { Alert, Link } from '@ztechapps/webui.util'
import { Template } from '@ztechapps/webui.data-tools'
import { useContext } from './Context'
import { ListHead } from './ListHead'
import { TaskTemplateValueInput } from './TaskTemplateValueInput'
import { RowExtension } from './RowExtension'

export const Layout = () => {
  const { setActiveTemplate } = useContext()
  return (
    <React.Fragment>
      <Alert type="warning">
        <ul>
          <li className="small">Add task by choosing the task template.</li>
          <li className="small">You can preview the tasks by expanding the row</li>
          <li className="small">
            You edit the templates from <Link>Settings</Link>{' '}
          </li>
        </ul>
      </Alert>
      <hr />
      <Template
        onChange={setActiveTemplate}
        category={'task_template'}
        components={{ ListHead, TemplateInputValue: TaskTemplateValueInput, TemplateDisplayValue: RowExtension }}
      />
      <Footer />
    </React.Fragment>
  )
}
